import * as React from 'react';

var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const SvgSmInstagram = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 34,
  height: 34,
  viewBox: "0 0 34 34",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M17 7.982c2.937 0 3.285.01 4.445.064 1.073.049 1.655.228 2.043.378.513.2.88.438 1.265.823.384.385.623.751.822 1.265.151.387.33.97.379 2.043.053 1.16.064 1.507.064 4.445 0 2.937-.011 3.285-.064 4.445-.049 1.072-.228 1.655-.379 2.042-.2.514-.438.88-.822 1.265a3.404 3.404 0 0 1-1.265.823c-.388.15-.97.33-2.043.378-1.16.053-1.508.064-4.445.064-2.937 0-3.285-.01-4.445-.064-1.073-.048-1.655-.227-2.043-.378a3.41 3.41 0 0 1-1.264-.823 3.405 3.405 0 0 1-.823-1.265c-.151-.387-.33-.97-.379-2.042-.053-1.16-.064-1.508-.064-4.445 0-2.938.011-3.285.064-4.445.05-1.073.228-1.655.379-2.043.2-.514.438-.88.822-1.265a3.404 3.404 0 0 1 1.265-.823c.388-.15.97-.33 2.043-.378 1.16-.053 1.508-.064 4.445-.064ZM17 6c-2.987 0-3.362.013-4.535.066-1.171.053-1.97.24-2.67.511a5.394 5.394 0 0 0-1.949 1.27 5.39 5.39 0 0 0-1.269 1.948c-.272.7-.458 1.5-.51 2.67C6.012 13.638 6 14.013 6 17s.013 3.362.066 4.535c.053 1.171.24 1.97.511 2.67a5.393 5.393 0 0 0 1.27 1.949 5.396 5.396 0 0 0 1.948 1.268c.7.273 1.5.459 2.67.512 1.173.053 1.548.066 4.535.066s3.362-.013 4.535-.066c1.171-.053 1.97-.24 2.67-.512a5.393 5.393 0 0 0 1.949-1.268 5.396 5.396 0 0 0 1.268-1.949c.273-.7.459-1.5.512-2.67.053-1.173.066-1.548.066-4.535s-.013-3.362-.066-4.535c-.053-1.171-.24-1.97-.512-2.67a5.394 5.394 0 0 0-1.268-1.949 5.397 5.397 0 0 0-1.949-1.269c-.7-.272-1.5-.458-2.67-.51C20.362 6.012 19.987 6 17 6Zm0 5.351a5.649 5.649 0 1 0 0 11.297 5.649 5.649 0 0 0 0-11.297Zm0 9.316a3.667 3.667 0 1 1 0-7.334 3.667 3.667 0 0 1 0 7.334Zm5.872-10.859a1.32 1.32 0 1 0 0 2.64 1.32 1.32 0 0 0 0-2.64Z",
  fill: "url(#a)"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
  id: "a",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "matrix(-5.99995 -22 65.7483 -17.93121 9 30)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.121,
  stopColor: "#FFD400"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.274,
  stopColor: "#FF7F22"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.307,
  stopColor: "#FF5722"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.396,
  stopColor: "#FF222F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.557,
  stopColor: "#FF0861"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.635,
  stopColor: "#FF22A7"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.848,
  stopColor: "#EB08FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.977,
  stopColor: "#7000FF"
})))));

export { SvgSmInstagram as default };
